// extracted by mini-css-extract-plugin
export default {"wrapper":"c8ej2MXebMzJcGT026Ln","description":"teB6OyI7LX60zMzdcCs2","settingsLink":"fQ7Gy_NBPaQm_P3IWh7a"};